import QuantModelViewer from "./QuantModelViewer";

export default QuantModelViewer;
